/**
 * Permission Level Enum
 *
 * Defines the available permission levels in the application.
 */
export enum PermissionLevel {
  DEV_TEAM_ADMIN = 'isDevTeamAdmin',
  AURIGA_SUPER_USER = 'isAurigaSuperUser',
  AURIGA_BUSINESS_USER = 'isAurigaBusinessUser',
  AURIGA_ADMIN = 'isAurigaAdmin',
}

/**
 * Permission Type Enum
 *
 * Defines the available permission types in the application.
 */
export enum PermissionType {
  READ = 'read',
  WRITE = 'write',
  NO_DATA = 'no_data',
  ADD_ACCESS = 'add_access',
  REMOVE_ACCESS = 'remove_access',
}

/**
 * User Context Type Interface
 *
 * Defines the structure of the user context provided by the UserProvider component.
 */
export interface UserContextType {
  /** User's login (Amazon Id) */
  username: string;

  /** User attributes from Cognito (Federate claims) */
  attributes: Record<string, string>;

  /** User permission levels (Based on knowledge from API permission-gated requests) */
  permissionLevels: Record<PermissionLevel, boolean>;

  /** User permissions (Derived from User permission levels) */
  permissions: Record<PermissionType, boolean>;

  /** Function to update User information */
  setUser: (user: Partial<UserContextType>) => void;

  /** Function to check if a User has a specific permission level */
  hasPermissionLevel: (permission: PermissionLevel) => boolean;

  /** Function to check if a User has a specific permission type */
  hasPermission: (permission: PermissionType) => boolean;
}
